import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import { Index } from "react-instantsearch";

import { useLoading, useCategory, useHomePage, useAlgolia, useSettings, useUsers } from "hooks";
import AlgoliaSearchWrapper from "components/AlgoliaSearchWrapper";
import CategoryPresenter from "presenters/CategoryPresenter";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";
import SearchBoxGeneric from "components/SearchBoxGeneric";
import SearchResults from "components/SearchResults";
import { CONTENT_TYPES_WITH_FILTER_PREFIX } from "enums/algoliaFilters";

import AboutUsInfo from "./components/AboutUsInfo";
import Hero from "./components/Hero";
import AboutUsPartnerLogos from "./components/AboutUsPartnerLogos";
import AboutUsEmail from "./components/AboutUsEmail";
import LearnMoreAboutStarringYou from "./components/LearnMoreAboutStarringYou";
import Artists from "./components/Artists";
import MusicVideos from "./components/MusicVideos";
import NativeAppsBanner from "./components/NativeAppsBanner";
import AboutUsBottom from "./components/AboutUsBottom";
import Apps from "./components/Apps";

const Content = styled(Grid)({
  "&.MuiGrid-root": {
    maxWidth: 1200,
  },
});

const AboutUs = () => {
  const slug = "music-video-ecards";
  const { createInitialUiStateFromMultiple } = useAlgolia();
  const {
    settings: { algolia },
  } = useSettings();
  const { loadCategoryFromContentful, category } = useCategory();
  const { func: loadCategoryWithLoaderFromContentful, isNotFinished: isPendingContentfulCategory } = useLoading(
    loadCategoryFromContentful,
  );
  const { currentUserLoaded } = useUsers();
  const { loadHomePage, carousel } = useHomePage();
  const { func: loadHomePageWithLoading, isNotFinished: isPendingHomePage } = useLoading(loadHomePage);

  useEffect(() => {
    loadHomePageWithLoading();
    loadCategoryWithLoaderFromContentful(slug);
  }, []);

  if (isPendingHomePage || isPendingContentfulCategory || !currentUserLoaded) return null;

  const configs = [
    {
      id: "hero",
      limit: 1,
      query: {
        query: AlgoliaCardsPresenter.queryTerm(carousel),
        facetFilters: CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouClip,
      },
    },
    {
      id: "musicVideos",
      limit: 2,
      query: {
        query: CategoryPresenter.query(category),
        facetFilters: CONTENT_TYPES_WITH_FILTER_PREFIX.starringYouEcard,
      },
    },
  ];
  const initialUiState = createInitialUiStateFromMultiple(configs);

  return (
    <Grid container justifyContent="center">
      <AlgoliaSearchWrapper context="about-us" initialUiState={initialUiState}>
        <Index indexName={algolia.indexName} indexId="hero">
          <SearchBoxGeneric
            initialQueryObject={initialUiState?.hero ?? {}}
            resultsSlot={SearchResults}
            resultsSlotProps={{
              WrappedComponent: Hero,
            }}
          />
        </Index>
        <Content item xs={10}>
          <AboutUsInfo />
          <AboutUsPartnerLogos />
          <AboutUsEmail />
        </Content>
        <LearnMoreAboutStarringYou />
        <Content item xs={10}>
          <Index indexName={algolia.indexName} indexId="musicVideos">
            <SearchBoxGeneric
              initialQueryObject={initialUiState?.musicVideos ?? {}}
              resultsSlot={SearchResults}
              resultsSlotProps={{
                WrappedComponent: MusicVideos,
              }}
            />
          </Index>
        </Content>
      </AlgoliaSearchWrapper>
      <Artists />
      <Content item xs={10}>
        <Apps />
      </Content>
      <NativeAppsBanner />
      <AboutUsBottom />
    </Grid>
  );
};

export default AboutUs;
